/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from '../../../../theme/css/sideMenu.css.shim.ngstyle';
import * as i1 from '@angular/core';
import * as i2 from '@angular/router';
import * as i3 from '@angular/common';
import * as i4 from 'ngx-bootstrap/collapse/collapse.directive';
import * as i5 from '../../../../../app/components/sidebar/sideMenu/sideMenu.component';
const styles_SideMenuComponent:any[] = [i0.styles];
export const RenderType_SideMenuComponent:i1.RendererType2 = i1.ɵcrt({encapsulation:0,
    styles:styles_SideMenuComponent,data:{}});
function View_SideMenuComponent_3(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),1,'button',[['class',
      'menu-item-button']],(null as any),[[(null as any),'click']],(_v,en,$event) => {
    var ad:boolean = true;
    if (('click' === en)) {
      const pd_0:any = ((<any>(<any>(<any>_v.parent).parent).context.$implicit.ButtonHandler()) !== false);
      ad = (pd_0 && ad);
    }
    return ad;
  },(null as any),(null as any))),(_l()(),i1.ɵted((null as any),['','']))],(null as any),
      (_ck,_v) => {
        const currVal_0:any = (<any>(<any>_v.parent).parent).context.$implicit.ButtonText;
        _ck(_v,1,0,currVal_0);
      });
}
function View_SideMenuComponent_2(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,[[2,0],['menuItem',1]],(null as any),11,'a',
      ([] as any[]),[[1,'target',0],[8,'href',4]],[[(null as any),'click']],(_v,en,
          $event) => {
        var ad:boolean = true;
        if (('click' === en)) {
          const pd_0:any = ((<any>i1.ɵnov(_v,1).onClick($event.button,$event.ctrlKey,
              $event.metaKey,$event.shiftKey)) !== false);
          ad = (pd_0 && ad);
        }
        return ad;
      },(null as any),(null as any))),i1.ɵdid(671744,[[7,4]],0,i2.RouterLinkWithHref,
      [i2.Router,i2.ActivatedRoute,i3.LocationStrategy],{routerLink:[0,'routerLink']},
      (null as any)),(_l()(),i1.ɵted((null as any),[' '])),(_l()(),i1.ɵeld(0,(null as any),
      (null as any),1,'i',([] as any[]),[[8,'className',0]],(null as any),(null as any),
      (null as any),(null as any))),(_l()(),i1.ɵted((null as any),['',''])),(_l()(),
      i1.ɵted((null as any),[' '])),(_l()(),i1.ɵeld(0,(null as any),(null as any),
      1,'p',[['class','menu-item-title']],(null as any),(null as any),(null as any),
      (null as any),(null as any))),(_l()(),i1.ɵted((null as any),['',''])),(_l()(),
      i1.ɵted((null as any),[' '])),(_l()(),i1.ɵand(16777216,(null as any),(null as any),
      1,(null as any),View_SideMenuComponent_3)),i1.ɵdid(16384,(null as any),0,i3.NgIf,
      [i1.ViewContainerRef,i1.TemplateRef],{ngIf:[0,'ngIf']},(null as any)),(_l()(),
      i1.ɵted((null as any),[' ']))],(_ck,_v) => {
    const currVal_2:any = (<any>_v.parent).context.$implicit.Path;
    _ck(_v,1,0,currVal_2);
    const currVal_6:any = (<any>_v.parent).context.$implicit.ShowButton;
    _ck(_v,10,0,currVal_6);
  },(_ck,_v) => {
    const currVal_0:any = i1.ɵnov(_v,1).target;
    const currVal_1:any = i1.ɵnov(_v,1).href;
    _ck(_v,0,0,currVal_0,currVal_1);
    const currVal_3:any = (<any>_v.parent).context.$implicit.IconClass;
    _ck(_v,3,0,currVal_3);
    const currVal_4:any = (<any>_v.parent).context.$implicit.Icon;
    _ck(_v,4,0,currVal_4);
    const currVal_5:any = (<any>_v.parent).context.$implicit.Name;
    _ck(_v,7,0,currVal_5);
  });
}
function View_SideMenuComponent_5(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),1,'button',[['class',
      'menu-item-button']],(null as any),[[(null as any),'click']],(_v,en,$event) => {
    var ad:boolean = true;
    if (('click' === en)) {
      const pd_0:any = ((<any>(<any>(<any>_v.parent).parent).context.$implicit.ButtonHandler()) !== false);
      ad = (pd_0 && ad);
    }
    return ad;
  },(null as any),(null as any))),(_l()(),i1.ɵted((null as any),['','']))],(null as any),
      (_ck,_v) => {
        const currVal_0:any = (<any>(<any>_v.parent).parent).context.$implicit.ButtonText;
        _ck(_v,1,0,currVal_0);
      });
}
function View_SideMenuComponent_4(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,[[2,0],['menuItem',1]],(null as any),10,'a',
      [['target','_blank']],[[1,'href',4]],(null as any),(null as any),(null as any),
      (null as any))),(_l()(),i1.ɵted((null as any),[' '])),(_l()(),i1.ɵeld(0,(null as any),
      (null as any),1,'i',([] as any[]),[[8,'className',0]],(null as any),(null as any),
      (null as any),(null as any))),(_l()(),i1.ɵted((null as any),['',''])),(_l()(),
      i1.ɵted((null as any),[' '])),(_l()(),i1.ɵeld(0,(null as any),(null as any),
      1,'p',[['class','menu-item-title']],(null as any),(null as any),(null as any),
      (null as any),(null as any))),(_l()(),i1.ɵted((null as any),['',''])),(_l()(),
      i1.ɵted((null as any),[' '])),(_l()(),i1.ɵand(16777216,(null as any),(null as any),
      1,(null as any),View_SideMenuComponent_5)),i1.ɵdid(16384,(null as any),0,i3.NgIf,
      [i1.ViewContainerRef,i1.TemplateRef],{ngIf:[0,'ngIf']},(null as any)),(_l()(),
      i1.ɵted((null as any),[' ']))],(_ck,_v) => {
    const currVal_4:any = (<any>_v.parent).context.$implicit.ShowButton;
    _ck(_v,9,0,currVal_4);
  },(_ck,_v) => {
    const currVal_0:any = (<any>_v.parent).context.$implicit.Path;
    _ck(_v,0,0,currVal_0);
    const currVal_1:any = (<any>_v.parent).context.$implicit.IconClass;
    _ck(_v,2,0,currVal_1);
    const currVal_2:any = (<any>_v.parent).context.$implicit.Icon;
    _ck(_v,3,0,currVal_2);
    const currVal_3:any = (<any>_v.parent).context.$implicit.Name;
    _ck(_v,6,0,currVal_3);
  });
}
function View_SideMenuComponent_7(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),0,'b',[['class',
      'caret']],(null as any),(null as any),(null as any),(null as any),(null as any)))],
      (null as any),(null as any));
}
function View_SideMenuComponent_6(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),10,'a',[['class',
      'collapsed'],['data-toggle','collapse']],[[1,'aria-expanded',0]],[[(null as any),
      'click']],(_v,en,$event) => {
    var ad:boolean = true;
    if (('click' === en)) {
      const pd_0:any = ((<any>((<any>_v.parent).context.$implicit.Collapsed = !(<any>_v.parent).context.$implicit.Collapsed)) !== false);
      ad = (pd_0 && ad);
    }
    return ad;
  },(null as any),(null as any))),(_l()(),i1.ɵted((null as any),[' '])),(_l()(),i1.ɵeld(0,
      (null as any),(null as any),1,'i',([] as any[]),[[8,'className',0]],(null as any),
      (null as any),(null as any),(null as any))),(_l()(),i1.ɵted((null as any),['',
      ''])),(_l()(),i1.ɵted((null as any),[' '])),(_l()(),i1.ɵeld(0,(null as any),
      (null as any),1,'p',[['class','menu-item-title']],(null as any),(null as any),
      (null as any),(null as any),(null as any))),(_l()(),i1.ɵted((null as any),['',
      ''])),(_l()(),i1.ɵted((null as any),[' '])),(_l()(),i1.ɵand(16777216,(null as any),
      (null as any),1,(null as any),View_SideMenuComponent_7)),i1.ɵdid(16384,(null as any),
      0,i3.NgIf,[i1.ViewContainerRef,i1.TemplateRef],{ngIf:[0,'ngIf']},(null as any)),
      (_l()(),i1.ɵted((null as any),[' ']))],(_ck,_v) => {
    const currVal_4:any = (<any>_v.parent).context.$implicit.ShowCaret;
    _ck(_v,9,0,currVal_4);
  },(_ck,_v) => {
    const currVal_0:boolean = !(<any>_v.parent).context.$implicit.Collapsed;
    _ck(_v,0,0,currVal_0);
    const currVal_1:any = (<any>_v.parent).context.$implicit.IconClass;
    _ck(_v,2,0,currVal_1);
    const currVal_2:any = (<any>_v.parent).context.$implicit.Icon;
    _ck(_v,3,0,currVal_2);
    const currVal_3:any = (<any>_v.parent).context.$implicit.Name;
    _ck(_v,6,0,currVal_3);
  });
}
function View_SideMenuComponent_10(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,[[4,0],['menuChild',1]],(null as any),9,'a',
      ([] as any[]),[[1,'target',0],[8,'href',4]],[[(null as any),'click']],(_v,en,
          $event) => {
        var ad:boolean = true;
        if (('click' === en)) {
          const pd_0:any = ((<any>i1.ɵnov(_v,1).onClick($event.button,$event.ctrlKey,
              $event.metaKey,$event.shiftKey)) !== false);
          ad = (pd_0 && ad);
        }
        return ad;
      },(null as any),(null as any))),i1.ɵdid(671744,[[9,4],[7,4]],0,i2.RouterLinkWithHref,
      [i2.Router,i2.ActivatedRoute,i3.LocationStrategy],{routerLink:[0,'routerLink']},
      (null as any)),i1.ɵpad(1),(_l()(),i1.ɵted((null as any),[' '])),(_l()(),i1.ɵeld(0,
      (null as any),(null as any),1,'span',([] as any[]),[[8,'className',0]],(null as any),
      (null as any),(null as any),(null as any))),(_l()(),i1.ɵted((null as any),['',
      ''])),(_l()(),i1.ɵted((null as any),[' '])),(_l()(),i1.ɵeld(0,(null as any),
      (null as any),1,'span',[['class','sidebar-normal']],(null as any),(null as any),
      (null as any),(null as any),(null as any))),(_l()(),i1.ɵted((null as any),['',
      ''])),(_l()(),i1.ɵted((null as any),[' ']))],(_ck,_v) => {
    const currVal_2:any = _ck(_v,2,0,(<any>_v.parent).context.$implicit.Path);
    _ck(_v,1,0,currVal_2);
  },(_ck,_v) => {
    const currVal_0:any = i1.ɵnov(_v,1).target;
    const currVal_1:any = i1.ɵnov(_v,1).href;
    _ck(_v,0,0,currVal_0,currVal_1);
    const currVal_3:any = (<any>_v.parent).context.$implicit.IconClass;
    _ck(_v,4,0,currVal_3);
    const currVal_4:any = (<any>_v.parent).context.$implicit.Icon;
    _ck(_v,5,0,currVal_4);
    const currVal_5:any = (<any>_v.parent).context.$implicit.Name;
    _ck(_v,8,0,currVal_5);
  });
}
function View_SideMenuComponent_11(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,[[4,0],['menuChild',1]],(null as any),7,'a',
      [['target','_blank']],[[1,'href',4]],(null as any),(null as any),(null as any),
      (null as any))),(_l()(),i1.ɵted((null as any),[' '])),(_l()(),i1.ɵeld(0,(null as any),
      (null as any),1,'span',([] as any[]),[[8,'className',0]],(null as any),(null as any),
      (null as any),(null as any))),(_l()(),i1.ɵted((null as any),['',''])),(_l()(),
      i1.ɵted((null as any),[' '])),(_l()(),i1.ɵeld(0,(null as any),(null as any),
      1,'span',[['class','sidebar-normal']],(null as any),(null as any),(null as any),
      (null as any),(null as any))),(_l()(),i1.ɵted((null as any),['',''])),(_l()(),
      i1.ɵted((null as any),[' ']))],(null as any),(_ck,_v) => {
    const currVal_0:any = (<any>_v.parent).context.$implicit.Path;
    _ck(_v,0,0,currVal_0);
    const currVal_1:any = (<any>_v.parent).context.$implicit.IconClass;
    _ck(_v,2,0,currVal_1);
    const currVal_2:any = (<any>_v.parent).context.$implicit.Icon;
    _ck(_v,3,0,currVal_2);
    const currVal_3:any = (<any>_v.parent).context.$implicit.Name;
    _ck(_v,6,0,currVal_3);
  });
}
function View_SideMenuComponent_9(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),16,'ul',[['class',
      'nav child']],(null as any),(null as any),(null as any),(null as any),(null as any))),
      (_l()(),i1.ɵted((null as any),[' '])),(_l()(),i1.ɵeld(0,(null as any),(null as any),
          13,'li',[['routerLinkActive','active']],(null as any),(null as any),(null as any),
          (null as any),(null as any))),i1.ɵdid(278528,(null as any),0,i3.NgClass,
          [i1.IterableDiffers,i1.KeyValueDiffers,i1.ElementRef,i1.Renderer],{ngClass:[0,
              'ngClass']},(null as any)),i1.ɵpod({'disabled':0}),i1.ɵdid(1720320,(null as any),
          2,i2.RouterLinkActive,[i2.Router,i1.ElementRef,i1.Renderer2,i1.ChangeDetectorRef],
          {routerLinkActiveOptions:[0,'routerLinkActiveOptions'],routerLinkActive:[1,
              'routerLinkActive']},(null as any)),i1.ɵqud(603979776,8,{links:1}),i1.ɵqud(603979776,
          9,{linksWithHrefs:1}),i1.ɵpod({exact:0}),(_l()(),i1.ɵted((null as any),[' '])),
      (_l()(),i1.ɵand(16777216,(null as any),(null as any),1,(null as any),View_SideMenuComponent_10)),
      i1.ɵdid(16384,(null as any),0,i3.NgIf,[i1.ViewContainerRef,i1.TemplateRef],{ngIf:[0,
          'ngIf']},(null as any)),(_l()(),i1.ɵted((null as any),[' '])),(_l()(),i1.ɵand(16777216,
          (null as any),(null as any),1,(null as any),View_SideMenuComponent_11)),
      i1.ɵdid(16384,(null as any),0,i3.NgIf,[i1.ViewContainerRef,i1.TemplateRef],{ngIf:[0,
          'ngIf']},(null as any)),(_l()(),i1.ɵted((null as any),[' '])),(_l()(),i1.ɵted((null as any),
          [' ']))],(_ck,_v) => {
    const currVal_0:any = _ck(_v,4,0,((<any>(<any>_v.parent).parent).context.$implicit.Disabled || _v.context.$implicit.Disabled));
    _ck(_v,3,0,currVal_0);
    const currVal_1:any = _ck(_v,8,0,_v.context.$implicit.Exact);
    const currVal_2:any = 'active';
    _ck(_v,5,0,currVal_1,currVal_2);
    const currVal_3:boolean = !_v.context.$implicit.Path.startsWith('http');
    _ck(_v,11,0,currVal_3);
    const currVal_4:any = _v.context.$implicit.Path.startsWith('http');
    _ck(_v,14,0,currVal_4);
  },(null as any));
}
function View_SideMenuComponent_8(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,[[3,0],['menuItemDiv',1]],(null as any),7,'div',
      [['class','collapse block']],[[8,'id',0],[2,'collapse',(null as any)],[4,'display',
          (null as any)],[2,'in',(null as any)],[2,'show',(null as any)],[1,'aria-expanded',
          0],[1,'aria-hidden',0],[2,'collapsing',(null as any)]],[[(null as any),'collapsed'],
          [(null as any),'expanded']],(_v,en,$event) => {
        var ad:boolean = true;
        var _co:any = _v.component;
        if (('collapsed' === en)) {
          const pd_0:any = ((<any>_co.onCollapsed($event)) !== false);
          ad = (pd_0 && ad);
        }
        if (('expanded' === en)) {
          const pd_1:any = ((<any>_co.onExpanded($event)) !== false);
          ad = (pd_1 && ad);
        }
        return ad;
      },(null as any),(null as any))),i1.ɵdid(278528,(null as any),0,i3.NgClass,[i1.IterableDiffers,
      i1.KeyValueDiffers,i1.ElementRef,i1.Renderer],{klass:[0,'klass'],ngClass:[1,
      'ngClass']},(null as any)),i1.ɵpod({'in show':0}),i1.ɵdid(16384,(null as any),
      0,i4.CollapseDirective,[i1.ElementRef,i1.Renderer],{collapse:[0,'collapse']},
      {collapsed:'collapsed',expanded:'expanded'}),(_l()(),i1.ɵted((null as any),[' '])),
      (_l()(),i1.ɵand(16777216,(null as any),(null as any),1,(null as any),View_SideMenuComponent_9)),
      i1.ɵdid(802816,(null as any),0,i3.NgForOf,[i1.ViewContainerRef,i1.TemplateRef,
          i1.IterableDiffers],{ngForOf:[0,'ngForOf']},(null as any)),(_l()(),i1.ɵted((null as any),
          [' ']))],(_ck,_v) => {
    const currVal_8:any = 'collapse block';
    const currVal_9:any = _ck(_v,2,0,!(<any>_v.parent).context.$implicit.Collapsed);
    _ck(_v,1,0,currVal_8,currVal_9);
    const currVal_10:any = (<any>_v.parent).context.$implicit.Collapsed;
    _ck(_v,3,0,currVal_10);
    const currVal_11:any = (<any>_v.parent).context.$implicit.Children;
    _ck(_v,6,0,currVal_11);
  },(_ck,_v) => {
    var _co:any = _v.component;
    const currVal_0:any = i1.ɵinlineInterpolate(2,'',_co.collapsedMenuPrefix,'_',(<any>_v.parent).context.index,
        '');
    const currVal_1:any = i1.ɵnov(_v,3).isCollapse;
    const currVal_2:any = i1.ɵnov(_v,3).display;
    const currVal_3:any = i1.ɵnov(_v,3).isExpanded;
    const currVal_4:any = i1.ɵnov(_v,3).isExpanded;
    const currVal_5:any = i1.ɵnov(_v,3).isExpanded;
    const currVal_6:any = i1.ɵnov(_v,3).isCollapsed;
    const currVal_7:any = i1.ɵnov(_v,3).isCollapsing;
    _ck(_v,0,0,currVal_0,currVal_1,currVal_2,currVal_3,currVal_4,currVal_5,currVal_6,
        currVal_7);
  });
}
function View_SideMenuComponent_1(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,[[1,0],['menuLi',1]],(null as any),19,'li',[['routerLinkActive',
      'active']],(null as any),(null as any),(null as any),(null as any),(null as any))),
      i1.ɵdid(278528,(null as any),0,i3.NgClass,[i1.IterableDiffers,i1.KeyValueDiffers,
          i1.ElementRef,i1.Renderer],{ngClass:[0,'ngClass']},(null as any)),i1.ɵpod({'disabled':0}),
      i1.ɵdid(1720320,(null as any),2,i2.RouterLinkActive,[i2.Router,i1.ElementRef,
          i1.Renderer2,i1.ChangeDetectorRef],{routerLinkActiveOptions:[0,'routerLinkActiveOptions'],
          routerLinkActive:[1,'routerLinkActive']},(null as any)),i1.ɵqud(603979776,
          6,{links:1}),i1.ɵqud(603979776,7,{linksWithHrefs:1}),i1.ɵpod({exact:0}),
      (_l()(),i1.ɵted((null as any),[' '])),(_l()(),i1.ɵand(16777216,(null as any),
          (null as any),1,(null as any),View_SideMenuComponent_2)),i1.ɵdid(16384,(null as any),
          0,i3.NgIf,[i1.ViewContainerRef,i1.TemplateRef],{ngIf:[0,'ngIf']},(null as any)),
      (_l()(),i1.ɵted((null as any),[' '])),(_l()(),i1.ɵand(16777216,(null as any),
          (null as any),1,(null as any),View_SideMenuComponent_4)),i1.ɵdid(16384,(null as any),
          0,i3.NgIf,[i1.ViewContainerRef,i1.TemplateRef],{ngIf:[0,'ngIf']},(null as any)),
      (_l()(),i1.ɵted((null as any),[' '])),(_l()(),i1.ɵand(16777216,(null as any),
          (null as any),1,(null as any),View_SideMenuComponent_6)),i1.ɵdid(16384,(null as any),
          0,i3.NgIf,[i1.ViewContainerRef,i1.TemplateRef],{ngIf:[0,'ngIf']},(null as any)),
      (_l()(),i1.ɵted((null as any),[' '])),(_l()(),i1.ɵand(16777216,(null as any),
          (null as any),1,(null as any),View_SideMenuComponent_8)),i1.ɵdid(16384,(null as any),
          0,i3.NgIf,[i1.ViewContainerRef,i1.TemplateRef],{ngIf:[0,'ngIf']},(null as any)),
      (_l()(),i1.ɵted((null as any),[' ']))],(_ck,_v) => {
    var _co:any = _v.component;
    const currVal_0:any = _ck(_v,2,0,_v.context.$implicit.Disabled);
    _ck(_v,1,0,currVal_0);
    const currVal_1:any = _ck(_v,6,0,true);
    const currVal_2:any = 'active';
    _ck(_v,3,0,currVal_1,currVal_2);
    const currVal_3:boolean = (!_co.stringHelper.isNullOrEmpty(_v.context.$implicit.Path) && !_v.context.$implicit.Path.startsWith('http'));
    _ck(_v,9,0,currVal_3);
    const currVal_4:boolean = (!_co.stringHelper.isNullOrEmpty(_v.context.$implicit.Path) && _v.context.$implicit.Path.startsWith('http'));
    _ck(_v,12,0,currVal_4);
    const currVal_5:any = _co.stringHelper.isNullOrEmpty(_v.context.$implicit.Path);
    _ck(_v,15,0,currVal_5);
    const currVal_6:any = _v.context.$implicit.Children;
    _ck(_v,18,0,currVal_6);
  },(null as any));
}
export function View_SideMenuComponent_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[i1.ɵqud(671088640,1,{menuLiRef:1}),i1.ɵqud(671088640,2,{menuRef:1}),
      i1.ɵqud(671088640,3,{menuDivRef:1}),i1.ɵqud(671088640,4,{menuChildRef:1}),i1.ɵqud(402653184,
          5,{movingTab:0}),(_l()(),i1.ɵeld(0,(null as any),(null as any),9,'div',[['class',
          'nav-container']],(null as any),(null as any),(null as any),(null as any),
          (null as any))),(_l()(),i1.ɵted((null as any),[' '])),(_l()(),i1.ɵeld(0,
          (null as any),(null as any),4,'ul',[['class','nav']],(null as any),(null as any),
          (null as any),(null as any),(null as any))),(_l()(),i1.ɵted((null as any),
          [' '])),(_l()(),i1.ɵand(16777216,(null as any),(null as any),1,(null as any),
          View_SideMenuComponent_1)),i1.ɵdid(802816,(null as any),0,i3.NgForOf,[i1.ViewContainerRef,
          i1.TemplateRef,i1.IterableDiffers],{ngForOf:[0,'ngForOf']},(null as any)),
      (_l()(),i1.ɵted((null as any),[' '])),(_l()(),i1.ɵted((null as any),[' '])),
      (_l()(),i1.ɵeld(0,[[5,0],['movingTab',1]],(null as any),0,'div',[['class','sidebar-moving-tab']],
          (null as any),(null as any),(null as any),(null as any),(null as any))),
      (_l()(),i1.ɵted((null as any),[' ']))],(_ck,_v) => {
    var _co:i5.SideMenuComponent = _v.component;
    const currVal_0:any = _co.menuItems;
    _ck(_v,10,0,currVal_0);
  },(null as any));
}
export function View_SideMenuComponent_Host_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),1,'side-menu',([] as any[]),
      (null as any),(null as any),(null as any),View_SideMenuComponent_0,RenderType_SideMenuComponent)),
      i1.ɵdid(4308992,(null as any),0,i5.SideMenuComponent,[i1.Renderer2,i2.Router],
          (null as any),(null as any))],(_ck,_v) => {
    _ck(_v,1,0);
  },(null as any));
}
export const SideMenuComponentNgFactory:i1.ComponentFactory<i5.SideMenuComponent> = i1.ɵccf('side-menu',
    i5.SideMenuComponent,View_SideMenuComponent_Host_0,{sideBar:'sideBar',menuItems:'menuItems',
        collapsedMenuPrefix:'collapsedMenuPrefix'},{},([] as any[]));
//# sourceMappingURL=data:application/json;base64,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



// WEBPACK FOOTER //
// ./compiled/app/components/sidebar/sideMenu/sideMenu.component.ngfactory.ts